import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import InviteList from '@/pages/invite/List'
import InviteListDetail from '@/pages/invite/ListDetail'
import WinList from '@/pages/win/List'
import Login from '@/pages/common/Login'
import Forget from '@/pages/common/Forget'
import Register from '@/pages/common/Register'
import Help from '@/pages/common/Help'
import NotFound from '@/pages/common/NotFound'
import MasterCenter from '@/pages/master/MasterCenter'
import MasterMore from '@/pages/master/More'
import MasterBasicInfo from '@/pages/master/BasicInfo'
import MasterInviteManagement from '@/pages/master/ListManagement'
import MasterProcessManagement from '@/pages/master/inviteProcess/ProcessManage'
import MasterBackStandard from '@/pages/master/inviteProcess/BackStandard'
import MasterReplyInvite from '@/pages/master/inviteProcess/ReplyInvite'
import MasterDownloadDoc from '@/pages/master/inviteProcess/DownloadDoc'
import MasterQuestions from '@/pages/master/inviteProcess/Questions'
import MasterLetter from '@/pages/master/inviteProcess/Letter'
import MasterReplyTender from '@/pages/master/inviteProcess/ReplyTender'

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',//首页-未登录
            name: 'index',
            component: Index,
            children:[
                {
                    name: 'slide1',
                    path: 'slide1',
                    component: Index
                },
                {
                    name: 'slide2',
                    path: 'slide2',
                    component: Index
                },
                {
                    name: 'slide3',
                    path: 'slide3',
                    component: Index
                },
                {
                    name: 'slide4',
                    path: 'slide4',
                    component: Index
                },
            ]
        },
        {
            path: '/invite-list',//招标公告
            name: 'invite-list',
            component: InviteList
        },
        {
            path: '/invite-listDetail/:id/:type',//招标公告 详情
            name: 'invite-listDetail',
            component: InviteListDetail
        },
        {
            path: '/win-list',//中标公告
            name: 'win-list',
            component: WinList
        },
        {
            path: '/login/:url',//登录
            name: 'login',
            component: Login
        },
        {
            path: '/forget',//忘记密码
            name: 'forget',
            component: Forget
        },
        {
            path: '/register',//注册页面
            name: 'register',
            component: Register
        },
        {
            path: '/help',//帮助中心
            name: 'help',
            component: Help
        },
        {
            path: '/not-found',//404
            name: 'not-found',
            component: NotFound
        },
        {
            path: '/master/center',//管理中心
            name: 'master-center',
            component: MasterCenter
        },
        {
            path: '/master/more/:activeName',//管理中心 查看更多
            name: 'master-more',
            component: MasterMore
        },
        {
            path: '/master/basicInfo',//基本信息
            // path: '/basicInfo/:id',//基本信息
            name: 'master-basicInfo',
            component: MasterBasicInfo
        },
        {
            path: '/master/inviteManagement',//招标管理
            name: 'master-inviteManagement',
            component: MasterInviteManagement,

        },
        {
            path: '/master/processManagement/:id',//招标管理,流程进度
            name: 'master-processManagement',
            component: MasterProcessManagement
        },
        {
            path: '/master/backStandard/:formId/:id/:entrance/:status',//招标管理,回标
            name: 'master-backStandard',
            component: MasterBackStandard
        },
        {
            path: '/master/replyInvite/:formId/:entrance',//招标管理,回复邀请函
            name: 'master-replyInvite',
            component: MasterReplyInvite,
            props: true
        },
        {
            path: '/master/downloadDoc/:formId/:entrance',//招标管理,下载标书
            name: 'master-downloadDoc',
            component: MasterDownloadDoc
        },
        {
            path: '/master/questions/:formId/:entrance',//招标管理,质疑/答疑
            name: 'master-questions',
            component: MasterQuestions
        },
        {
            path: '/master/replyTender/:formId/:entrance',//招标管理,询标回复
            name: 'master-replyTender',
            component: MasterReplyTender
        },
        {
            path: '/master/letter/:formId/:entrance',//招标管理,中标通知书/感谢信
            name: 'master-letter',
            component: MasterLetter
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js